var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.625H3.75C3.40482 3.625 3.125 3.90482 3.125 4.25V16.75C3.125 17.0952 3.40482 17.375 3.75 17.375H16.25C16.5952 17.375 16.875 17.0952 16.875 16.75V4.25C16.875 3.90482 16.5952 3.625 16.25 3.625Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.375V4.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.375V4.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 7.375H16.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.75C10.5178 11.75 10.9375 11.3303 10.9375 10.8125C10.9375 10.2947 10.5178 9.875 10 9.875C9.48223 9.875 9.0625 10.2947 9.0625 10.8125C9.0625 11.3303 9.48223 11.75 10 11.75Z",
    fill: "#919191"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 11.75C13.9553 11.75 14.375 11.3303 14.375 10.8125C14.375 10.2947 13.9553 9.875 13.4375 9.875C12.9197 9.875 12.5 10.2947 12.5 10.8125C12.5 11.3303 12.9197 11.75 13.4375 11.75Z",
    fill: "#919191"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 14.875C7.08027 14.875 7.5 14.4553 7.5 13.9375C7.5 13.4197 7.08027 13 6.5625 13C6.04473 13 5.625 13.4197 5.625 13.9375C5.625 14.4553 6.04473 14.875 6.5625 14.875Z",
    fill: "#919191"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.875C10.5178 14.875 10.9375 14.4553 10.9375 13.9375C10.9375 13.4197 10.5178 13 10 13C9.48223 13 9.0625 13.4197 9.0625 13.9375C9.0625 14.4553 9.48223 14.875 10 14.875Z",
    fill: "#919191"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 14.875C13.9553 14.875 14.375 14.4553 14.375 13.9375C14.375 13.4197 13.9553 13 13.4375 13C12.9197 13 12.5 13.4197 12.5 13.9375C12.5 14.4553 12.9197 14.875 13.4375 14.875Z",
    fill: "#919191"
  })));
};
export default SvgCalendar;